import React, { useContext } from 'react'
import QuizSectionTemplate from '../QuizSectionTemplate'
import { Flex } from '@mantine/core'
import QuizParameterTemplate from '../QuizParameterTemplate'
import { QuizContext } from '@context/QuizContext'
import RoundButton from '@components/button/RoundButton'
import accounting from 'accounting'
import QuizParameterTemplateDeficit from '../QuizParameterTemplateDeficit'
import BackButton from '../BackButton'

const QuizSectionFive = () => {
    const {
        form5,
        nextStep,
        currentStep,
        estimated_saving_source_for_retirement,
        required_funds_for_retirement,
        dificit_funds_retirement,
    } = useContext(QuizContext)
    if (currentStep !== 5) {
        return <></>
    }

    return (
        <form onSubmit={form5!.onSubmit(() => nextStep!())}>
            <QuizSectionTemplate
                section={5}
                title='คำนวณหาส่วนขาดของเงินทุนเพื่อการเกษียณ'
            >
                <QuizParameterTemplate
                    afterLabel='บาท'
                    label='เงินทุนเพื่อการเกษียณอายุทั้งหมดที่ต้องมี ณ ปีที่เกษียณอายุ'
                    type='value'
                >
                    {accounting.formatMoney(required_funds_for_retirement!, {
                        symbol: '',
                        precision: 2,
                    }) ?? 0}
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='บาท'
                    label={`ประมาณการมูลค่าแหล่งเงินออมเพื่อการเกษียณที่เตรียมไว้แล้ว ณ ปีที่เกษียณอายุ`}
                    type='value'
                >
                    {accounting.formatMoney(
                        estimated_saving_source_for_retirement!,
                        {
                            symbol: '',
                            precision: 2,
                        }
                    ) ?? 0}
                </QuizParameterTemplate>
                <QuizParameterTemplateDeficit
                    afterLabel={dificit_funds_retirement! <= 0 ? '' : 'บาท'}
                    label={`ส่วนขาดของเงินทุนเพื่อการเกษียณ`}
                    bg={dificit_funds_retirement! <= 0 ? 'green' : 'redt.4'}
                >
                    {dificit_funds_retirement! <= 0
                        ? 'เพียงพอ'
                        : accounting.formatMoney(dificit_funds_retirement!, {
                              symbol: '',
                              precision: 2,
                          }) ?? 0}
                </QuizParameterTemplateDeficit>
            </QuizSectionTemplate>
            <Flex
                mb='xl'
                direction={{ xs: 'column', sm: 'row' }}
                gap='lg'
                justify={{ xs: 'center', sm: 'space-between' }}
            >
                <BackButton />
                <RoundButton type='submit' label='ถัดไป' />
            </Flex>
        </form>
    )
}

export default QuizSectionFive
